import axios from '../../axios'

/*
 * 爬虫文章数据接口
 */
// 获取爬虫文章分页列表
export const getArticleList = (data) => {
    return axios({
        url: '/api/base/admin/crawler/article/page',
        method: 'get',
        data
    })
}

// 文章id查询
export const getArticleId = (data) => {
    return axios({
        url: '/api/base/admin/crawler/article/get',
        method: 'get',
        data
    })
}

// 文章导出
export const reparticleExport = (data) => {
    return axios({
        url: '/api/base/admin/crawler/article/export',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/reptile/reparticle.js